import { render, staticRenderFns } from "./DonationForm.vue?vue&type=template&id=6de89d7c"
import script from "./DonationForm.vue?vue&type=script&lang=js"
export * from "./DonationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\laragon\\www\\lifeline-pro\\wp-content\\plugins\\lifeline-donation-pro\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6de89d7c')) {
      api.createRecord('6de89d7c', component.options)
    } else {
      api.reload('6de89d7c', component.options)
    }
    module.hot.accept("./DonationForm.vue?vue&type=template&id=6de89d7c", function () {
      api.rerender('6de89d7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/DonationForm.vue"
export default component.exports